const breadcrumbsHome = { name: 'Home', pathName: '/' }
const breadcrumbsRetailers = { name: 'Lojas', pathName: '/client-units' }

export default [
  {
    path: '/client-units',
    component: () => import('@/modules/client_units/views/pages/ClientUnits.vue'),
    meta: {
      title: 'Lojas',
      breadcrumbs: [breadcrumbsHome, breadcrumbsRetailers]
    }
  }
]
